module.exports = __webpack_public_path__ + "static/media/G.a026e253.png";